export const NAME = 'user';
export const AUTH_TOKEN_ID = 'mnd-authorization';
export const AUTH_REFRESH_ID = 'mnd-authorization-refresh';
export const DIALOGS = {
  TAKEN: 'TAKEN',
  MAGIC: 'MAGIC',
  LOGIN: 'LOGIN',
  CREATE: 'CREATE',
  CREATE_TERMS: 'CREATE_TERMS',
  CREATE_CONFIRMATION: 'CREATE_CONFIRMATION',
  VERIFICATION: 'VERIFICATION',
  UNVERIFIED: 'UNVERIFIED',
};
export const ERROR_CODES = {
  TAKEN: 'taken',
};
